import { CalendarOutlined, MedicineBoxOutlined, UserOutlined } from '@ant-design/icons';
import { Col, Row, Button, Select } from 'antd';
import { consultationHistory } from 'containers/App/selectors';
import { Formik, FormikHelpers } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isActive } from '../../pages/ConsultationHistory/slices';
import Wrap from './styles';

const { Option } = Select;

type InititalValue = {
  patient_name: string;
  facility_name: string;
  period_of_no_visit_medical: string;
};

type Props = {
  onSearch: (value: InititalValue) => Promise<void>;
};

const initialValues = {
  patient_name: '',
  facility_name: '',
  period_of_no_visit_medical: '2',
};

const resetFormSearch = {
  patient_name: '',
  facility_name: '',
  period_of_no_visit_medical: '',
};

const SearchConsultation = ({ onSearch }: Props) => {
  const dispatch = useDispatch();
  const [option, setOption] = useState<string>('2');

  const { search_loading } = useSelector(consultationHistory);

  const handleSubmit = async (values: InititalValue, form: FormikHelpers<InititalValue>) => {
    values.period_of_no_visit_medical = option;
    await onSearch(values);
    dispatch(isActive(false));
    form.setSubmitting(false);
  };

  const setOptionMonth = useCallback((value: any) => {
    setOption(value);
  }, []);

  const resetForm = () => {
    dispatch(isActive(true));
    onSearch(resetFormSearch);
    setOption('2');
  };

  return (
    <Wrap>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        onReset={resetForm}
        render={() => (
          <Form>
            <Row className="detail">
              <Col span={15}>
                <Row>
                  <Col span={24} className="search">
                    <CalendarOutlined className="icon1" />
                    <p className="standardBoldFont">未受診期間</p>
                    <Form.Item name="period_of_no_visit_medical">
                      <Select
                        size={'large'}
                        defaultValue="直近２ヶ月 未受診者"
                        value={option}
                        onChange={setOptionMonth}
                        className="input-search-stk standardBoldFont"
                      >
                        <Option value="2">直近２ヶ月 未受診者</Option>
                        <Option value="3">3ヶ月以上 未受診者</Option>
                        <Option value="4">4ヶ月以上 未受診者</Option>
                        <Option value="5">5ヶ月以上 未受診者</Option>
                        <Option value="6">6ヶ月以上 未受診者</Option>
                        <Option value="7">7ヶ月以上 未受診者</Option>
                        <Option value="8">8ヶ月以上 未受診者</Option>
                        <Option value="9">9ヶ月以上 未受診者</Option>
                        <Option value="10">10ヶ月以上 未受診者</Option>
                        <Option value="11">11ヶ月以上 未受診者</Option>
                        <Option value="12">12ヶ月以上 未受診者</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={14} className="search">
                    <MedicineBoxOutlined className="icon1" />
                    <p className="standardBoldFont">医療機関名</p>
                    <Form.Item name="facility_name">
                      <Input className="input-search-stk" name="facility_name" />
                    </Form.Item>
                  </Col>
                  <Col span={10} className="search">
                    <UserOutlined className="icon1" />
                    <p className="standardBoldFont">患者名</p>
                    <Form.Item name="patient_name">
                      <Input className="input-search-stk" name="patient_name" />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={6}>
                <Button htmlType="reset" className="Standard backSetup" loading={search_loading}>
                  リセット
                </Button>
                <SubmitButton className="btnSearch Standard btnDefault">絞り込み表示</SubmitButton>
              </Col>
            </Row>
          </Form>
        )}
      />
    </Wrap>
  );
};

export default SearchConsultation;
